//add spinner to button
function addSpinner(ele) {
  if(ele.hasClass('fa-cart-plus')){
      ele.removeClass('fa-cart-plus')
         .addClass('fa-spinner fa-spin')
  };
  if(ele.hasClass('fa-paper-plane')){
    ele.removeClass('fa-paper-plane')
       .addClass('fa-spinner fa-spin')
  };
};
//remove spinner
function removeSpinner(ele,newIcon) {
  if(ele.hasClass('fa-spinner')){
      ele.removeClass('fa-spinner fa-spin')
         .addClass(newIcon);
  };
};
// watch the order form list
function addItemToCart(item, amount, refresh =  true) {
  var postUrl = 'wishlist/items/add';
  var formData = {
    elementId: item,
    amount: amount,
    action: "wishlist/items/add"
  };
  // Add the CSRF Token
  formData[csrfTokenName] = csrfTokenValue;
  // process the form
  $.ajax({
    type : 'POST',
    url : postUrl,
    data : formData,
    dataType : 'json'
  })
  .done(function(data) {
      if (data.success === true)
      {
        if (ccAnalytics) {
          gtag('event', 'click', {
            // Event parameters
            'event_category': 'button',
            //'event_action': 'click',	
            'event_label': 'add to cart'
          });
          console.log("added to cart, gtag sent.");
        } else {
          console.log("added to cart.");
        };
        
        if (refresh === true) {location.reload();};
      }
      else
      {
        console.log("error: can't add the item");
      }
  });
};
// watch the order form list
function deleteItemsFromCart(items, refresh =  true) {
  var postUrl = 'wishlist/items/remove';
  var formData = {
    action: "wishlist/items/remove"
  };
  // Add the CSRF Token
  formData[csrfTokenName] = csrfTokenValue;

  var itemsType = typeof items;
    if (itemsType === 'number' ) {
    formData["elementId"] = items;  
  } else {
    var i;
    for (i = 1; i <=items.length; ++i) {
      formData["items["+i+"][elementId]"] = items[i-1];
    }
  }
  // process the form
  $.ajax({
    type : 'POST',
    url : postUrl,
    data : formData,
    dataType : 'json',
    timeout: 350
  })
  .done(function(data) {
      if (data.success === true)
      {
          if (refresh === true) {location.reload();};
      }
      else
      {
        console.log("error: can't delete the item");
      }
  });
};
//delete list (reset cart)
function deleteList(list, refresh = true) {
  var listID = list;
  var postUrl = 'wishlist/lists/delete';
  var formData = {
    action: "wishlist/lists/delete"
  };
  // Add the CSRF Token
  formData[csrfTokenName] = csrfTokenValue;
  formData["listId"] = listID;  
  // process the form
  $.ajax({
    type : 'POST',
    url : postUrl,
    data : formData,
    dataType : 'json',
    timeout: 350
  })
  .done(function(data) {
      if (data.success === true)
      {
          if (refresh === true) {location.reload();};
          console.log('list deleted');
      }
      else
      {
        console.log("error: can't delete the item");
      }
  });
  return;
};
//update item amount
function updateProductAmount(item, amount, refresh =  true) {
  var postUrl = 'wishlist/items/update';
  var formData = {
    itemId: item,
    fields: { 'amount': amount },
    action: "wishlist/items/update"
  };
  // Add the CSRF Token
  formData[csrfTokenName] = csrfTokenValue;
  // process the form
  $.ajax({
    type : 'POST',
    url : postUrl,
    data : formData,
    dataType : 'json'
  })
  .done(function(data) {
      if (data.success === true)
      {
          console.log('update amount success');
          //console.log(formData);
          if (refresh === true) {location.reload();};
          //return true;
          // RESPONSE
          // {success: true}
          // var redirect = $('#contact-form input[name=redirect]').val();
          // $(location).attr('href', redirect);
      }
      else
      {
        console.log("error: can't update the item amount");
      }
  });
};
//delete item from list
$( '.delete-item-button' ).on('click', function(event) {
  deleteItemsFromCart( $(this).data('item-id') );
});
//order form - change item amount
$( ".item-amount" ).change(function() {
  updateProductAmount( $(this).data('item-id'), $(this).val() );
});
//check fileuploadsize
$('input[type="file"]').change(function() { 
  var giveAlert = false;
  var files = this.files;
  $.each(files, function (i, file) {
    if (file.size > 5000000) {
      giveAlert = true;
    }
  });
  if (giveAlert === true) {
    alert("Maximální povolená velikost souboru je 5MB! Vyberte prosím jinou přílohu.");
    $(this).val('');
  };
}); 
// add cart items to order-list field - general function
$('#formie-form-rentPreorderForm,#formie-form-slovakiaPreorderForm').on('onBeforeFormieSubmit', function(e) {
  var submitButton = $(":submit",this)[0];
  addSpinner( $(submitButton).find('svg') );
  //collect items, their amounts and fill the textarea - try to finish data
  var orderItems = $('.order-item-singleline');
  var shoppingListHeadline = "Poptávané položky:\n------------------\n";
  var shoppingList = "";
  var itemsToDelete = [];
  var listId = $('.order-product-list').data('list-id');
  $('.order-item-singleline').each( function(i){
    shoppingList += "[" + (i+1) + ".] - " + $(this).data('item-title') + ", množství: " + $(this).data('item-amount') + "ks\n";
  });
  if ( shoppingList != "" ) { shoppingList = shoppingListHeadline + shoppingList;};
  $('#fields-formie-form-rent-preorder-form-order-list,#fields-formie-form-slovakia-preorder-form-order-list').val(shoppingList);
  removeSpinner( $(submitButton).find('svg'), 'fa-paper-plane' );
});
$('#formie-form-rentPreorderForm,#formie-form-slovakiaPreorderForm').on('onAfterFormieSubmit', function(e) {  
  var listId = $('.order-product-list').data('list-id');
  var lastPage = false;
  if (e.detail.nextPageId === null ) { lastPage = true; }
  if (lastPage) {
    deleteList(listId,false);
  }
});
//add item to cart
$( ".item-addtocart" ).on("click", function(event) {
  //console.log('adding');
  addSpinner( $(this).find('svg') );
  addItemToCart( $(this).data('product-id'), $(this).data('amount') );
});
//update amount (add one)
$( ".item-updatecart" ).on("click", function(event) {
  //console.log('updating');
  var ele = $(this).find('svg');
  if(ele.hasClass('fa-cart-plus')){
      ele.removeClass('fa-cart-plus')
         .addClass('fa-spinner fa-spin')
  };
  updateProductAmount( $(this).data('item-id'), $(this).data('amount') );
});

